export default {
      id: "outputs-text-2-usage",
      viewBox: "0 0 27 14",
      url: __webpack_public_path__ + "img/icons.svg#outputs-text-2",
      toString: function () {
        return this.url;
      }
    }